export const AND = 'And' as const;
export const OR = 'Or' as const;

export type FilterLogicType = typeof AND | typeof OR;
